import { Grid } from "@mui/material";
import PointsTransactionsTable from "./table";
import PointsHeader from "./header";

const PointsTransactions = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PointsHeader />
      </Grid>
      <Grid item xs={12}>
        <PointsTransactionsTable />
      </Grid>
    </Grid>
  );
};

export default PointsTransactions;
